module.exports = __webpack_public_path__ + "static/media/A14.2238ae83.jpg";